import { notification, Progress } from "antd";
import { useContext, useEffect, useState } from "react";
import { ConvContext } from "../../pages/ConversationContext";
import { calculatePercentile } from "../../pages/utils/commonUtils";

const ImportContactsNotification = ({ open }) => {
  const [notificationAPI, notificationContextHolder] = notification.useNotification();

  useEffect(() => {
    if (open) {
      notificationAPI.destroy();
      notificationAPI.open({
        message: <div className="hs-color-BlackRussian hs-fw-bolder"> Importing Contacts </div>,
        description: <Description notificationAPI={notificationAPI} />,
        placement: "topRight",
        duration: 0,
        icon: null,
      });
    }
  }, [notificationAPI, open]);

  return <div>{notificationContextHolder}</div>;
};

const Description = ({ notificationAPI }) => {
  const { conversationContext } = useContext(ConvContext);
  const [importStatus, setImportStatus] = useState("processing");
  const [percentile, setPercentile] = useState(0);

  useEffect(() => {
    const recordsProcessed = conversationContext?.importedContacts?.recordsProcessed;
    const totalRecords = conversationContext?.importedContacts?.totalRecords;
    const percentile = calculatePercentile(recordsProcessed, totalRecords);
    setPercentile(percentile);
    if (conversationContext?.importedContacts?.import_status) {
      setImportStatus(conversationContext?.importedContacts?.import_status);
      setTimeout(() => {
        notificationAPI.destroy();
      }, 3500);
    }
  }, [
    conversationContext?.importedContacts,
    conversationContext?.importedContacts?.recordsProcessed,
    conversationContext?.importedContacts?.totalRecords,
    notificationAPI,
  ]);
  return (
    <div>
      {" "}
      <div className="hs-color-grey">
        {importStatus === "processing"
          ? `Processing contacts... ${percentile}%`
          : importStatus === "failed"
          ? "Contacts Import failed"
          : "Contacts Imported successfully"}
      </div>
      <div>
        <Progress
          strokeColor={"#605bff"}
          percent={importStatus === "processing" ? percentile : 100}
          showInfo={false}
          status={importStatus === "processing" ? "active" : "success"}
        />
      </div>
    </div>
  );
};

export default ImportContactsNotification;
